import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="relative mb-6">
            <span className="text-8xl md:text-9xl font-black font-heading text-background-200 select-none">
              404
            </span>
          </div>
          <div className="relative z-10">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-background-100">
              <i className="ri-compass-discover-line text-3xl text-foreground-300"></i>
            </div>
            <h1 className="text-xl md:text-2xl font-bold text-foreground-900 mb-2">
              页面走丢了
            </h1>
            <p className="text-foreground-500 text-sm mb-2">
              您访问的页面不存在或已移除
            </p>
            <p className="text-foreground-300 text-xs font-mono mb-6">
              {location.pathname}
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
              <Link
                to="/"
                className="px-6 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-home-line mr-1"></i> 返回首页
              </Link>
              <Link
                to="/category/all"
                className="px-6 py-2.5 text-foreground-600 text-sm font-medium rounded-full border border-background-300 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line mr-1"></i> 浏览漫画
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}